'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlLovOptions', function ($compile) {
  return {
    terminal: true,
    // mandatory, and so is the highest possible priority
    priority: 1000,
    restrict: "A",
    compile: function compile($el, $attrs) {
      // what are we doing here you ask ?
      // we are cheating : intercepting the compilation via 'terminal', adding the ngOptions directive,
      // remove this one, and compilating again in the link method we returns.
      // this was really easier before ng, 1.4, when ngOptions was an attribute for select and not a directive
      var lovName = $attrs.tlLovOptions,
        onetimeWatch = true,
        // TODO : parametrize ?
        watchPrefix = onetimeWatch ? "::" : "";
      $attrs.$set("ngOptions", "o.id as o.label for o in " + watchPrefix + lovName);
      $attrs.$set("tlLovOptions", null);
      return {
        pre: function postLink($scope, $el, $attrs) {
          $compile($el)($scope);
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlLovOptions.js
// module id = 2905
// module chunks = 13